import React, { useEffect, useState } from "react"
import * as styles from "./anchors-nav.module.scss"
import { useIsMobile } from "../../../hooks"

type Props = {
  anchors: { id: string; title: string }[]
}

const AnchorNavigation: React.FC<Props> = ({ anchors }) => {
  const [activeId, setActiveId] = useState<string | null>(null)
  const isMobile = useIsMobile()
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      const offset = isMobile ? 140 : 110

      for (const anchor of anchors) {
        const el = document.getElementById(anchor.id)
        if (el) {
          const top = el.offsetTop - offset
          const bottom = top + el.offsetHeight

          if (scrollY >= top && scrollY < bottom) {
            setActiveId(anchor.id)
            return
          }
        }
      }
    }

    window.addEventListener("scroll", handleScroll)
    handleScroll()
    return () => window.removeEventListener("scroll", handleScroll)
  }, [anchors])

  if (!anchors || anchors?.length === 0) {
    return null
  }
  return (
    <div className={styles.anchorNav}>
      <ul>
        {anchors.map(anchor => (
          <li key={anchor.id} className={activeId === anchor.id ? styles.active : ""}>
            <a href={`#${anchor.id}`}>
              {activeId !== anchor.id && !isMobile && <span className={styles.anchorLine}></span>}
              <span className={styles.anchorText}>{anchor.title}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default AnchorNavigation
